/* eslint-disable import/no-default-export */
import { HeaderTestIds } from '@trello/webdriverio-tests';
import { IconName } from 'app/common/components/controls/icon';
import { Noun, Verb, trackUe } from '@trello/analytics';
import { EnterpriseMenuPopoverId } from 'app/gamma/src/components/popovers/popover-ids';
import { State } from 'app/gamma/src/modules/types';
import React, {
  lazy,
  Suspense,
  FunctionComponent,
  useRef,
  useCallback,
} from 'react';
import { connect } from 'react-redux';
import { isEnterpriseAdmin } from 'app/gamma/src/selectors/enterprises';
import HeaderButton from './button';
import { usePopover } from '../popover';

const EnterpriseMenuPopoverPromise = import(
  /* webpackChunkName: "enterprise-menu-popover" */ 'app/gamma/src/components/popovers/enterprise-menu'
);
const EnterpriseMenuPopover = lazy(() => EnterpriseMenuPopoverPromise);

interface StateProps {
  isAdmin: boolean;
}

const EnterpriseMenuButton: FunctionComponent<StateProps> = ({ isAdmin }) => {
  const menuButtonRef = useRef<HTMLButtonElement>(null);
  const { isPopoverShown, showPopover } = usePopover({
    name: EnterpriseMenuPopoverId,
  });
  const onClick = useCallback(() => {
    trackUe({
      category: Noun.HEADER,
      verb: Verb.OPENS,
      directObj: Noun.ENTERPRISE_DASHBOARD_MENU,
      method: 'by clicking enterprise button in header',
    });
    showPopover();
  }, [showPopover]);
  if (!isAdmin) {
    return null;
  }

  return (
    <>
      <HeaderButton
        icon={IconName.Enterprise}
        onClick={onClick}
        ref={menuButtonRef}
        testId={HeaderTestIds.EnterpriseDashboardButton}
      />
      {isPopoverShown && (
        <Suspense fallback={null}>
          <EnterpriseMenuPopover target={() => menuButtonRef.current} />
        </Suspense>
      )}
    </>
  );
};

const mapStateToProps = (state: State): StateProps => ({
  isAdmin: isEnterpriseAdmin(state),
});

export default connect(mapStateToProps)(EnterpriseMenuButton);
